import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AdminContractSpec from './components/admin/contractSpecs/contractSpec';
import AdminContractSpecs from './components/admin/contractSpecs/contractSpecs';
import AdminEmployee from './components/admin/employees/employee';
import AdminEmployees from './components/admin/employees/employees';
import AdminJobs from './components/admin/jobs/jobs';
import AdminOrganization from './components/admin/organizations/organization';
import AdminOrganizations from './components/admin/organizations/organizations';
import AdminPicker from './components/admin/picker/pickers';
import Asset from './components/assets/asset';
import Assets from './components/assets/assets';
import Cabinet from './components/forms/cabinet';
import Dashboard from './components/admin/dashboard/dashboard';
import Design from './components/admin/design/design';
import Document from './components/documents/document';
import Documents from './components/documents/documents';
import DocumentsUpload from './components/documents/documentsUpload';
import Forbidden from './components/error/forbidden';
import FormPDFViewer from './components/forms/formPDFViewer';
import FormEditorContainer from './components/forms/formEditorContainer';
import IssueDetailView from './components/issues/issueDetailView';
import Issues from './components/issues/issues';
import IssueEditor from './components/issues/issueEditor';
import FluidIssueEditorContainer from './components/issues/fluidIssueEditorContainer';
import JobEditorContainer from './components/admin/jobs/jobEditorContainer';
import Logout from './components/login/logout';
import EntraCallback from './components/login/entraCallback';
import NotFound from './components/error/notFound';
import ReportsContainer from './components/reports/reportsContainer';
import Report from './components/reports/report';
import ReportEditorContainer from './components/reports/reportEditorContainer';
import FormAnnotationEditor from './components/forms/formAnnotationEditor';
import FormDocumentAnnotationEditor from './components/forms/formDocumentAnnotationEditor';
import ReportTags from './components/admin/tags/reportTags';
import Summaries from './components/admin/summaries/summaries';
import ReportAnnotationEditor from './components/reportDocuments/reportAnnotationEditor';
import DirectFormContainer from './components/forms/directFormContainer';
import DirectFormCreator from './components/forms/directFormCreator';
const routes = /*#__PURE__*/React.createElement("div", {
  style: {
    marginBottom: '30px'
  }
}, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/",
  component: ReportsContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/file-cabinet",
  component: ReportsContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/reports/:id",
  component: Report
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/reports/edit/:id",
  component: ReportEditorContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/reports/edit/:id/:section",
  component: ReportEditorContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/reportDocuments/edit/:reportDocumentID",
  component: ReportAnnotationEditor
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/logout",
  component: Logout
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/auth/callback",
  component: EntraCallback
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/library",
  component: Documents
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/library/upload",
  component: DocumentsUpload
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/library/:id",
  component: Document
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/issues",
  component: Issues
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/issues/detailView/:reportDocumentID",
  component: IssueDetailView
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/issues/detailView/:reportDocumentID/:issueID",
  component: IssueDetailView
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/issues/:id",
  component: FluidIssueEditorContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/issues/edit/:id",
  component: IssueEditor
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/cabinets/:cabinetIdentifier",
  component: Cabinet
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/cabinets/:cabinetIdentifier/:formTypeIdentifier/:id/pdfview",
  component: FormPDFViewer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/cabinets/:cabinetIdentifier/:formTypeIdentifier/:id/:section?",
  component: FormEditorContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/forms/:formTypeIdentifier/:id/:section?",
  component: FormEditorContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/formDocuments/edit/:formID/:formDocumentID",
  component: FormDocumentAnnotationEditor
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/annotations",
  component: FormAnnotationEditor
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/directForms/new/:formType",
  component: DirectFormCreator
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/directForms/:id/:section?",
  component: DirectFormContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/jobs",
  component: AdminJobs
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/jobs/:id/:formID/:section?",
  component: JobEditorContainer
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/employees",
  component: AdminEmployees
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/employees/:id",
  component: AdminEmployee
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/employees/:id/:section",
  component: AdminEmployee
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/assets",
  component: Assets
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/pickers",
  component: AdminPicker
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/assets/:id",
  component: Asset
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/assets/:id/:section",
  component: Asset
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/organizations",
  component: AdminOrganizations
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/organizations/:id",
  component: AdminOrganization
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/organizations/:id/:section",
  component: AdminOrganization
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/contractSpecs",
  component: AdminContractSpecs
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/contractSpecs/:id",
  component: AdminContractSpec
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/contractSpecs/:id/:section",
  component: AdminContractSpec
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/summaries",
  component: Summaries
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/summaries/:section",
  component: Summaries
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/dashboard",
  component: Dashboard
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/design",
  component: Design
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/admin/reportTags",
  component: ReportTags
}), /*#__PURE__*/React.createElement(Route, {
  exact: true,
  path: "/accessDenied",
  component: Forbidden
}), /*#__PURE__*/React.createElement(Route, {
  component: NotFound
})));
export default routes;